import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
}
const CTAButton = ({
  text,
  href = 'https://trynymera.com/products/nymera-sleep-strips'
}: CTAButtonProps) => {
  return <a href={href} className="w-full py-3 sm:py-4 px-4 sm:px-6 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md text-center transition duration-200 text-sm sm:text-base md:text-lg uppercase tracking-wide shadow-md hover:shadow-lg inline-block" data-id="element-212">
      {text}
    </a>;
};
export default CTAButton;